'use strict';

export default ($q, $http, $rootScope, $location, analytics, payModal, utils, userModel, modal, payments, currencyModel, analyticsSa, fastPayModal, braintreeModal) => {
  'ngInject';

  const analyticsContentType = 'product';
  const membershipCategoryName = 'Membership';
  const membershipEventName = 'PaidForMembership';

  return {
    paymentData: null,

    showPaymentWindow(paymentData) {
      paymentData.meta.PAYMENT_TYPE = 'SUBSCRIPTION';

      const CLICK_TRACK = 'click-membershipSelection';
      analyticsSa.track({action: CLICK_TRACK, data: {price: paymentData.price, duration: paymentData.duration, currency: userModel.item.preferences.currency}});
      if (typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart');
      }
      return braintreeModal.open(paymentData, this);


      // fast payment available if -
      var fastPaymentAvailable = userModel.item.membership.activeContract;

      if (fastPaymentAvailable) {
        return fastPayModal.open(paymentData, this);
      } else {
        return payModal.open(paymentData, this);
      }
    },

    processPayment(paymentData) {
      delete paymentData.meta;

      return this.sendPaymentData(paymentData);
    },

    sendPaymentData(paymentData) {
      this.paymentData = paymentData;
      // adyen-encrypted-data: "enccypreData",
      // currency: "EUR",
      // duration: "1month" / "3month" / "12month"
      // isForFuturePayments: 1/0
      // price: 59.99
      var url = utils.getApiUrl('/membership/' + userModel.item.id + '/recurring');
      return new $q((resolve, reject) => {
        $http.post(url, paymentData)
          .then((response) => resolve(response))
          .catch(reject);
      });
    },

    sendFastPaymentData(paymentData) {
      delete paymentData.meta;
      this.paymentData = paymentData;
      // currency: "EUR",
      // duration: "1month" / "3month" / "12month"
      // price: 59.99
      var url = utils.getApiUrl('/membership/' + userModel.item.id + '/contract');
      return new $q((resolve, reject) => {
        $http.post(url, paymentData)
          .then((response) => resolve(response))
          .catch(reject);
      });
    },

    showMembershipSuccessWindow(authResult, membership) {
      // authResult data model:
      // authResult is just a string
      // membership data model:
      // price: $stateParams.price,
      // currency: $stateParams.currency,
      // duration: parseInt($stateParams.duration),
      var paymentStatus = payments.getPaymentStatus(authResult);
      var scope = $rootScope.$new();

      if (['successful', 'pending'].indexOf(paymentStatus) > -1) {
        analytics.track(membershipEventName, {
          category: membershipCategoryName,
          value: membership.price,
          content_type: analyticsContentType,
          content_ids: userModel.item.id,
          currency: currencyModel.getValue(),
        });
        const CLICK_TRACK = 'event-membershipBuySuccess';
        analyticsSa.track({action: CLICK_TRACK, data: {price: membership.price, duration: membership.duration, currency: userModel.item.preferences.currency}});

        if (typeof fbq !== 'undefined') {
          fbq('track', 'Purchase');
        }

        // Linkedin pixel for purchase
        var linkedinEl = document.createElement("div");
        linkedinEl.innerHTML = '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3819929&conversionId=5396641&fmt=gif" />';
        document.body.appendChild(linkedinEl);

        // Kisunas Affilates pixel
        let orderId = ('random-'+Math.random());
        let pixelUrl = '<img src="https://www.shareasale.com/sale.cfm?tracking='+orderId+'&amount='+membership.price+'&merchantID=115429&transtype=sale" width="1" height="1">';
        var shareSaleEl = document.createElement("div");
        shareSaleEl.innerHTML = pixelUrl;
        document.body.appendChild(shareSaleEl);
      }

      scope.membership = membership;
      scope.status = paymentStatus;
      scope.retry = () => {

        this.showPaymentWindow();
      };

      // we probably don't have sa-membership-payment-success available (load it!)
      return modal.open({
        template: '<sa-membership-payment-success status="{{ status }}" membership="membership" done="close()" retry="retry()"></sa-membership-payment-success>',
        scope: scope,
        closeOnStateChange: true
      }).result;
    },

    getBraintreeReloadUrl(authCode, paymentData) {
        this.paymentData = paymentData;
        return this.getReloadURL(authCode);
    },
    getReloadURL(authCode) {
      var reloadURL = `${$location.path()}?authResult=${authCode}&duration=${this.paymentData.duration}&price=${this.paymentData.price}&currency=${this.paymentData.currency}`;

      return reloadURL;
    },
  };
};



// WEBPACK FOOTER //
// ./app/src/services/payments_subscription.service.js